module.exports = __webpack_public_path__ + "img/bill.b1e807ad.svg";